module.exports = __webpack_public_path__ + "img/android.ff56c9f8.jpg";